export class HttpConnection {
    constructor() {
        this.header = this.headerOptions();
    }

    headerOptions() {
        const token = localStorage.getItem('token');

        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        //headers.append('Access-Control-Allow-Origin', '*');
        headers.append('Authorization', 'Bearer ' + token);
        return headers;
    }

    get = (array) => {
        let options = {
            method: 'GET',
            mode: 'cors',
            headers: this.header,
        };

        return fetch(array.url, options)
            .then(function (response) {
                if(response.ok) {
                    return response.json();
                }
            })
            .then(function (json) {
                //console.log(JSON.stringify(json));
                return json;
            }).catch(function (error) {
                return {
                    statusCode: "400",
                    message: "error: " + error.message,
                }
            });
    }
    post = (array) => {
        let options = {
            method: 'POST',
            headers: this.header,
            mode: 'cors',
            body: JSON.stringify(array.parameter)
        };

        return fetch(array.url, options)
            .then(function (response) {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok.')
            })
            .then(function (json) {
                //console.log(JSON.stringify(json));
                return json;
            }).catch(function (error) {
                return {
                    statusCode: "400",
                    message: "error: " + error.message,
                }
            });
    }
    put = (array) => {
        let options = {
            method: 'PUT',
            headers: this.header,
            mode: 'cors',
            body: JSON.stringify(array.parameter)
        };

        return fetch(array.url, options)
            .then(function (response) {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok.')
            })
            .then(function (json) {
                //console.log(JSON.stringify(json));
                return json;
            }).catch(function (error) {
                return {
                    statusCode: "400",
                    message: "error: " + error.message,
                }
            });
    }
    delete = (array) => {
        let options = {
            method: 'DELETE',
            headers: this.header,
            mode: 'cors',
            body: JSON.stringify(array.parameter)
        };

        return fetch(array.url, options)
            .then(function (response) {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok.')
            })
            .then(function (json) {
                //console.log(JSON.stringify(json));
                return json;
            }).catch(function (error) {
                return {
                    statusCode: "400",
                    message: "error: " + error.message,
                }
            });
    }
}